<div class="container">
  <div class="row justify-content-center">
    <section class="col-12 col-xl-11">
      <div class="row">
        <section class="col-md-8">
          <form ngForm name="bookingGroupEventForm">
            <div class="row">
              <div class="col-12">
                <h3 class="titel">{{ 'Group visit title' | translate }}</h3>
                <p class="titel">{{ 'Group visit description' | translate }}</p>
              </div>
              <div class="col-md-12">
                <app-input [title]="'Organization name' | translate" [name]="'name_of_organization'" [(ngModel)]="name_of_organization"
                  required></app-input>
              </div>
              <div class="col-md-6">
                <app-input [title]="'First name (contact person)' | translate" [name]="'name_of_contact'" [(ngModel)]="name_of_contact"
                  required></app-input>
              </div>
              <div class="col-md-6">
                <app-input [title]="'Last name (contact person)' | translate" [name]="'surname_of_contact'" [(ngModel)]="surname_of_contact"
                  required></app-input>
              </div>
              <div class="col-md-6">
                <app-input [title]="'Street, house number' | translate" [name]="'street'" [(ngModel)]="street" required></app-input>
              </div>
              <div class="col-md-6">
                <app-input [title]="'ZIP // City' | translate" [name]="'zip'" [(ngModel)]="zip" required></app-input>
              </div>
              <div class="col-md-6">
                <app-input [title]="'Phone' | translate" [name]="'phone'" [(ngModel)]="phone" required></app-input>
              </div>
              <div class="col-md-6">
                <app-input [title]="'E-Mail' | translate" [name]="'email'" [(ngModel)]="email" email required></app-input>
              </div>
              <div class="col-md-6">
                <app-datepicker [title]='"Date" | translate' [name]="'dateOfBirth'" [(ngModel)]="date" [startView]="'month'"
                  required appValidateAge></app-datepicker>
              </div>
              <div class="col-md-6">
                <app-input [title]="'Time' | translate" [name]="'time'" [(ngModel)]="time" required></app-input>
              </div>
              <div class="col-md-12">
                <app-textarea [title]="'Other information, alternative dates, alternative times' | translate" [name]="'other_info'"
                  [(ngModel)]="other_info"></app-textarea>
              </div>
              <section class="col-md-12">
                <div class="ng-box">
                  <div class="container">
                    <div class="row">
                      <div class="col-12 col-lg-6 align-self-center text-center text-lg-left">
                        <div>
                          <h3>{{ 'Number Of Guests' | translate }}</h3>
                          <p>{{ '' | translate }}</p>
                        </div>
                      </div>
                      <div class="col-12 d-block d-lg-none">
                        <hr>
                      </div>
                      <div class="col article-one align-self-center justify-content-center justify-content-lg-end text-right my-2 my-lg-0">
                        <app-up-down [counter]="guestCount" [isLast]="true">
                        </app-up-down>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <div class="col-md-4">

                <app-button [title]="'Go' | translate" (click)="onSend()" [buttonCssClass]="'button button-right button-black float-right'"
                  [disabled]="!isFormValid  || formProcessing"></app-button>
              </div>
            </div>
          </form>
        </section>

        <section class="col-md-1 d-none d-md-block">
          <div class="row separator-v">
            <div></div>
          </div>
        </section>

        <section class="col-md-3">
          <ul class="list-square">
            <li>{{ '13,00 € // Person' | translate }}</li>
            <li>{{ '90 Minutent' | translate }}</li>
            <li>{{ 'Only by appointment' | translate }}</li>
            <li>{{ 'Also possible on Monday and Tuesday mornings' | translate }}</li>
          </ul>
          <hr>
          <p class="infotext infotext-group-contact">{{ 'Group visit note' | translate }}</p>
        </section>
      </div>
    </section>
  </div>
</div>
